import { Grid } from '@material-ui/core';
import { rhythm } from 'Themes/typography';
import React from 'react';
import { takeInitials } from 'Utils';
import styled from 'styled-components';

const Container = styled.div`
  padding: ${rhythm(1.5)} 0 ${rhythm(2)};
  border-top: 2px solid ${({ theme }) => theme.palette.blue.light};
  border-bottom: 2px solid ${({ theme }) => theme.palette.blue.light};
  height: 100%;
`;

const Heading = styled.h1`
  font-size: 1rem;
`;

const Title = styled.div`
  font-weight: 600;
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
  font-size: 0.75rem;
`;

const Values = styled.div`
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
  font-size: 0.875rem;
  color: ${({ theme }) => theme.palette.blue.main};
  display: inline-flex;
  align-items: center;
`;

const Image = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  margin-left: 0.5rem;
`;

const ImagePlaceholder = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  margin-right: 0.5rem;
  background: ${({ theme }) => theme.palette.blue.main};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
`;

const ContactDetails = ({ details }) => (
  <Container>
    <Heading>Contact details</Heading>
    <Grid container spacing={8} alignItems="center">
      <Grid item xs={4}>
        <Title>Manufacturer</Title>
      </Grid>
      <Grid item xs>
        <Values>{details.manufacturer}</Values>
      </Grid>
    </Grid>
    <Grid container spacing={8} alignItems="center">
      <Grid item xs={4}>
        <Title>Contact</Title>
      </Grid>
      <Grid item xs>
        <Values>
          {details.image ? (
            <Image src={details.image} />
          ) : (
            <ImagePlaceholder>{takeInitials(details.contact)}</ImagePlaceholder>
          )}
          <span>{details.contact}</span>
        </Values>
      </Grid>
    </Grid>
    <Grid container spacing={8} alignItems="center">
      <Grid item xs={4}>
        <Title>Email</Title>
      </Grid>
      <Grid item xs>
        <Values>{details.email}</Values>
      </Grid>
    </Grid>
    <Grid container spacing={8} alignItems="center">
      <Grid item xs={4}>
        <Title>Phone</Title>
      </Grid>
      <Grid item xs>
        <Values>{details.mobile}</Values>
      </Grid>
    </Grid>
  </Container>
);

export default ContactDetails;
